<template>
  <v-dialog v-model="show" max-width="500px">
    <v-card flat dense>
      <v-card-title>
        {{ $t('BUTTON.UPDATE') }} {{ $t('PLANNINGS.TASKS.EVENT.ITEM') }}
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <accept-action-list
          @accept="accept"
          @close="close"
        ></accept-action-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import AcceptActionList from '@/modules/plannings/components/Event/UpdateActionList.vue';
export default {
  name: 'UpdateTaskDialog',

  components: {
    AcceptActionList
  },

  props: {
    show: Boolean
  },

  methods: {
    accept(value) {
      this.$emit('accept', value);
    },

    close() {
      this.$emit('update:show', !this.show);
    }
  }
};
</script>
